import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { atom, useAtom } from "jotai";
import Maintenance from "../contact_create/maintenance";


const kubunAtom = atom();
const expAtom = atom();
const nasAtom = atom();
const hciAtom = atom();
const swAtom = atom();
const etcAtom = atom();
const targetAtom = atom();
const productsServiceAtom = atom();
const osAtom = atom();
const titleAtom = atom();
const detailAtom = atom();
const youtoAtom = atom();
const releaseAtom = atom();
const yosanAtom = atom();
const cnameAtom = atom();
const sectionAtom = atom();
const nameAtom = atom();
const kenAtom = atom();
const addressAtom = atom();
const tel1Atom = atom();
const tel2Atom = atom();
const tel3Atom = atom();
const emailAtom = atom();
const email2Atom = atom();
const ecnameAtom = atom();
const esectionAtom = atom();
const enameAtom = atom();
const etelAtom = atom();
const eemailAtom = atom();

const kubunMap = {"1": "製品お問い合わせ", "2": "購入相談" };
const youtoMap = {"1": "自社導入", "2": "お客様提案" };
const releaseMap = {"1": "導入済み", "2": "未定", "3": "3ヶ月以内", "4": "半年以内", "5": "1年以内", "6": "1年以上先" };

function MainComponent({ handleLoading }) {

    document.title = "ファーストコンタクトセンター | NEC";
    const location = useLocation();
    const navigate = useNavigate();
    
    const [kubun, setKubun] = useAtom(kubunAtom);
    const [exp, setExp] = useAtom(expAtom);
    const [nas, setNas] = useAtom(nasAtom);
    const [hci, setHci] = useAtom(hciAtom);
    const [sw, setSw] = useAtom(swAtom);
    const [etc, setEtc] = useAtom(etcAtom);
    const [target, setTarget] = useAtom(targetAtom);
    const [productsService, setProductsService] = useAtom(productsServiceAtom);
    const [os, setOs] = useAtom(osAtom);
    const [title, setTitle] = useAtom(titleAtom);
    const [detail, setDetail] = useAtom(detailAtom);
    const [youto, setYouto] = useAtom(youtoAtom);
    const [release, setRelease] = useAtom(releaseAtom);
    const [yosan, setYosan] = useAtom(yosanAtom);
    const [cname, setCname] = useAtom(cnameAtom);
    const [section, setSection] = useAtom(sectionAtom);
    const [name, setName] = useAtom(nameAtom);
    const [ken, setKen] = useAtom(kenAtom);
    const [address, setAddress] = useAtom(addressAtom);
    const [tel1, setTel1] = useAtom(tel1Atom);
    const [tel2, setTel2] = useAtom(tel2Atom);
    const [tel3, setTel3] = useAtom(tel3Atom);
    const [email, setEmail] = useAtom(emailAtom);
    const [email2, setEmail2] = useAtom(email2Atom);
    const [ecname, setEcname] = useAtom(ecnameAtom); 
    const [esection, setEsection] = useAtom(esectionAtom);
    const [ename, setEname] = useAtom(enameAtom);
    const [etel, setEtel] = useAtom(etelAtom);
    const [eemail, setEemail] = useAtom(eemailAtom);


    setKubun(location.state.kubun);
    setExp(location.state.exp);
    setNas(location.state.nas);
    setHci(location.state.hci);
    setSw(location.state.sw);
    setEtc(location.state.etc);

    const targetArr = [];
    if (location.state.exp) {
        targetArr.push("Express5800シリーズ");
    }
    if (location.state.nas) {
        targetArr.push("iStorageシリーズ");
    }
    if (location.state.hci) {
        targetArr.push("ハイパーコンバージドインフラストラクチャ");
    }
    if (location.state.sw) {
        targetArr.push("ソフトウェア・サービス");
    }
    if (location.state.etc) {
        targetArr.push("その他");
    }
    setTarget(targetArr.join(" / "));

    setProductsService(location.state.productsService);
    setOs(location.state.os);
    setTitle(location.state.title);
    setDetail(location.state.detail);
    setYouto(location.state.youto);
    setRelease(location.state.release);
    setYosan(location.state.yosan);
    setCname(location.state.cname);
    setSection(location.state.section);
    setName(location.state.name);
    setKen(location.state.ken);
    setAddress(location.state.address);
    setTel1(location.state.tel1);
    setTel2(location.state.tel2);
    setTel3(location.state.tel3);
    setEmail(location.state.email);
    setEmail2(location.state.email2);
    setEmail2(location.state.email2);
    setEcname(location.state.ecname);
    setEsection(location.state.esection);
    setEname(location.state.ename);
    setEtel(location.state.etel);
    setEemail(location.state.eemail);

    function initInput() {
    }


    const goBack = () => {

        navigate("/contact_create", {
            state: {
                page: true
            }
        });
        initInput();
    }
    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <h2 className="mod-hdg-l2-02">
                        <span>お問い合わせ完了</span>
                    </h2>
                    <div className="mod-tbl-form">
                        <div style={{ marginBottom: "15px" }}>
                            <div>下記内容でシステム導入のご相談を承りました。</div>
                            <div><strong>{email}</strong>宛てに受付のメールを送付しましたのでご確認ください。</div>
                        </div>
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ・ご相談区分</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="kubun">{kubunMap[kubun]}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="title">件名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="title" className="text-pre-wrap">{title}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お問い合わせ・ご相談内容</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="detail" className="text-pre-wrap">{detail}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">正式会社名／団体名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="cname" className="text-pre-wrap">{cname}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご所属</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="section" className="text-pre-wrap">{section}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お名前</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="name" className="text-pre-wrap">{name}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">ご住所</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <ul class="list">
                                            <li>
                                                <div class="mod-txt mb-0">
                                                    <b class="label"><strong>都道府県</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="mod-txt">{ken}</div>
                                            </li>
                                            <li>
                                                <div class="mod-txt mb-0">
                                                    <b class="label"><strong>市区町村以降</strong></b>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="mod-txt">{address}</div>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">お電話番号</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="tel1" className="text-pre-wrap">{tel1}-{tel2}-{tel3}</div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">E-Mail</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="email" className="text-pre-wrap">{email}</div>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left"
                                onClick={goBack}>TOPに戻る</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MainComponent;